import React, { memo } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import { CSSTransition } from 'react-transition-group';
import './BlocoMinhasAssembleias.scss';
import {
  AssembleiasIcon,
  CircleArrowRight,
} from 'plataforma-fundacao-componentes';
const rootClassName = 'bloco-minhas-assembleias';

interface BlocoMinhasAssembleiasProps {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  title?: string;
  linked?: string;
  subtitle?: string;
  notFound?: string;
  showNotFound?: boolean;
  className?: string;
  onClick?: (event?: any) => void;
}

function BlocoMinhasAssembleias(props: BlocoMinhasAssembleiasProps) {
  return (
    <div
      className={clsx([
        rootClassName,
        props.showNotFound ? 'disabled' : '',
        props?.className!,
      ])}
      onClick={props.onClick}
    >
      <CSSTransition
        in={props.showNotFound}
        timeout={300}
        classNames='fade'
        mountOnEnter
        unmountOnExit
      >
        <div className={`${rootClassName}-not-found`}>{props.notFound}</div>
      </CSSTransition>
      <div className={`${rootClassName}-first-line`}>
        <div className={`${rootClassName}-icon`}>
          {props.leftIcon ?? <AssembleiasIcon />}
        </div>
        <div className={`${rootClassName}-icon`}>
          {props.rightIcon ?? <CircleArrowRight />}
        </div>
      </div>
      <div>
        <div className={`${rootClassName}-title`}>{props.title}</div>
        <div className={`${rootClassName}-sub-title`}>
          <span>{props.linked}</span>
          {props.subtitle}
        </div>
      </div>
    </div>
  );
}

export default memo(BlocoMinhasAssembleias);
